import React from 'react';
import PropTypes from 'prop-types';
import DateTime from '_class/DateTime';
import { useTranslate } from 'lib/translate';
import { capitalize } from 'helpers/content';
import { Collapsible } from 'UI';
import { Icon } from '@haldor/ui';
import './_displayFeedbacks.scss';
import User from '_class/User';
import { useSelector } from 'react-redux';

var DisplayFeedbacks = function DisplayFeedbacks(_ref) {
  var feedbacks = _ref.feedbacks,
      resource = _ref.resource,
      resources = _ref.resources,
      isStudentOverView = _ref.isStudentOverView;
  var translate = useTranslate();
  var currentUser = useSelector(function (state) {
    return state.user.currentUser;
  });
  var user = new User(currentUser);
  /**
   * @returns {array} feedbacks
   */

  var getPublicFeedbacks = function getPublicFeedbacks() {
    if (feedbacks == null) {
      return [];
    }

    return feedbacks.filter(function (feedback) {
      return !feedback.isPrivate;
    });
  };
  /**
   * @returns {array} feedbacks
   */


  var getPrivateFeedbacks = function getPrivateFeedbacks() {
    if (feedbacks == null || currentUser == null) {
      return [];
    }

    return feedbacks.filter(function (feedback) {
      return feedback.isPrivate && feedback.editorUser != null && feedback.editorUser.userId == currentUser.id;
    });
  };

  var getResource = function getResource(feedback) {
    if (resource != null) {
      return resource;
    }

    if (resources.length > 0) {
      return resources.find(function (resource) {
        return feedback.assessmentBlockPartId == resource.id;
      });
    }

    return null;
  };
  /**
   * @param {string} permission
   * @param {array} permissions
   */


  var renderPermission = function renderPermission(permission, permissions) {
    var active = permissions.find(function (perm) {
      return perm.target == permission && perm.referenceType == 'ASSESSMENTFEEDBACK';
    }) != null;
    return /*#__PURE__*/React.createElement("div", {
      className: "permission"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: active ? "Eye" : "Eye_Off"
    }), translate(capitalize(permission)));
  };

  var renderFeedback = function renderFeedback(feedback, index) {
    var resource = getResource(feedback);
    var permissions = [];

    if (resource != null && !feedback.isPrivate) {
      permissions = resource.permissions;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "feedback",
      key: feedback.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "size-12 feedback-item-header",
      style: {
        marginBottom: '.4rem'
      }
    }, /*#__PURE__*/React.createElement("div", null, feedback.navigationObject != null ? feedback.navigationObject.referenceType == 'PLAN' ? translate('Plan') : translate('Assignment') : null, feedback.navigationObject != null ? ' • ' + feedback.navigationObject.title : null), /*#__PURE__*/React.createElement("div", null, feedback.editorUser != null ? feedback.editorUser.firstName + ' ' + feedback.editorUser.lastName : null, ' • ' + new DateTime(feedback.published ? feedback.published : feedback.created).getLongDate())), /*#__PURE__*/React.createElement("div", {
      className: "feedback-item"
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: feedback.text
      }
    }), resource != null && !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
      className: "permissions"
    }, renderPermission('STUDENT', permissions), renderPermission('GUARDIAN', permissions)) : null));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "display-feedbacks"
  }, getPublicFeedbacks().length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "collapsible-container"
  }, /*#__PURE__*/React.createElement(Collapsible, {
    ignorePropsUpdate: true,
    open: true,
    trigger: translate('Feedback')
  }, getPublicFeedbacks().map(renderFeedback))) : null, getPrivateFeedbacks().length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "collapsible-container"
  }, /*#__PURE__*/React.createElement(Collapsible, {
    trigger: translate('Personal notes')
  }, getPrivateFeedbacks().map(renderFeedback))) : null);
};

DisplayFeedbacks.propTypes = {
  feedbacks: PropTypes.array,
  resource: PropTypes.object,
  resources: PropTypes.array
};
DisplayFeedbacks.defaultProps = {
  resource: null,
  resources: []
};
export default DisplayFeedbacks;